// extracted by mini-css-extract-plugin
export default {"password":"Password_password__LZ8WM"};